<template>
    <div class="detail">
        <el-dialog
            title="详情"
            :visible.sync="dialogVisible"
            width="800px"
            :before-close="handleClose"
        >
            <div class="content" v-loading="load" v-if="!isNull">
                <el-form inline>
                    <el-form-item label="活动主题：">
                        {{ rowData.title }}
                    </el-form-item>
                    <el-form-item label="活动时间：">
                        {{ rowData.start_time + " ~ " + rowData.end_time }}
                    </el-form-item>
                </el-form>
                <div :class="listData ? '' : 'hide'">
                    <div
                        id="myChart"
                        style="width: 100%; height: 400px; margin-bottom: 40px"
                    ></div>
                </div>
                <div :class="arrData && arrData.length ? '' : 'hide'">
                    <div id="myChart1" style="width: 100%; height: 400px"></div>
                </div>
            </div>
            <el-empty description="暂无内容！" v-else></el-empty>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" type="primary">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
let echarts = require("echarts");
export default {
    data() {
        return {
            dialogVisible: false,
            load: false,
            rowData: {
                title: "-",
                start_time: "0000-00-00",
                end_time: "0000-00-00",
            },
            listData: {
                city: [],
                num: [],
            },
            arrData: [],
            isNull: false,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    methods: {
        ...mapActions({
            statisticsDetail: "commodity/statisticsDetail",
        }),
        handleClose() {
            this.dialogVisible = false;
            this.listData = {
                city: [],
                num: [],
            };
            this.arrData = [];
            this.isNull=false;
        },
        getDetail(row) {
            this.load = true;
            this.listData = {
                city: [],
                num: [],
            };
            this.arrData = [];
            this.rowData = row;
            let opt = {
                token: this.getToken,
                id: row.id,
            };
            this.statisticsDetail(opt).then((res) => {
                if (res.code == 1) {
                    if (res.data.city_data && res.data.city_data.length > 0) {
                        res.data.city_data.forEach((v) => {
                            this.listData.city.push(v.city);
                            this.listData.num.push(v.total_user_number);
                        });
                        this.drawLine();
                    }

                    if (res.data.area_data && res.data.area_data.length > 0) {
                        res.data.area_data.forEach((v) => {
                            let tit;
                            switch (v.area) {
                                case "1":
                                    tit = "华北地区";
                                    break;
                                case "2":
                                    tit = "东北地区";
                                    break;
                                case "3":
                                    tit = "华东地区";
                                    break;
                                case "4":
                                    tit = "中南地区";
                                    break;
                                case "5":
                                    tit = "西南地区";
                                    break;
                                case "6":
                                    tit = "西北地区";
                                    break;
                                default:
                                    break;
                            }
                            let opt = {
                                value: v.total_user_number,
                                name: tit,
                            };
                            this.arrData.push(opt);
                        });
                        this.drawLine1();
                    }
                    if (
                        !res.data ||
                        (res.data.area_data.length == 0 &&
                            res.data.city_data.length == 0)
                    ) {
                        this.isNull = true;
                    }

                    this.load = false;
                    this.listData = res.data.city_data;
                }
            });
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("myChart"),
                "light"
            );
            let option = {
                title: {
                    text: "用户分布",
                    left: "left",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        data: this.listData.city,
                        axisTick: {
                            alignWithLabel: true,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "直接访问",
                        type: "bar",
                        barWidth: "25%",
                        data: this.listData.num,
                    },
                ],
            };

            // 绘制图表
            myChart.setOption(option);
        },
        drawLine1() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("myChart1"),
                "light"
            );
            var option;

            var option;

            option = {
                title: {
                    text: "地区占比",
                    left: "left",
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "5%",
                    left: "center",
                },
                series: [
                    {
                        name: "访问来源",
                        type: "pie",
                        radius: ["40%", "70%"],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: "#fff",
                            borderWidth: 2,
                        },
                        label: {
                            show: false,
                            position: "center",
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: "24",
                                fontWeight: "bold",
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: this.arrData,
                    },
                ],
            };

            if (option && typeof option === "object") {
                myChart.setOption(option);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    min-height: 300px;
    height: 550px;
    overflow-y: auto;
    .el-form {
        display: flex;
        justify-content: space-between;
    }
}
.hide {
    & > div {
        visibility: hidden;
        height: 0 !important;
        overflow: hidden;
    }
}
</style>